import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "bg-table-header" }
const _hoisted_4 = { class: "text-left p-3" }
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = { class: "text-left p-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-left p-3"
}
const _hoisted_8 = { class: "text-left p-3" }
const _hoisted_9 = { class: "text-left p-3" }
const _hoisted_10 = { class: "text-left p-3" }
const _hoisted_11 = { class: "p-3" }
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_15 = {
  key: 0,
  class: "p-3 text-gray-500"
}
const _hoisted_16 = { class: "p-3 text-gray-500" }
const _hoisted_17 = { class: "p-3 text-gray-500" }
const _hoisted_18 = { class: "p-3 text-gray-500" }

import { computed, Component } from "vue";
import { CheckIcon, ClockIcon, XIcon, CogIcon } from "@heroicons/vue/outline";
import Process from "@/types/documents/process/Process";
import ProcessUser from "@/types/documents/process/ProcessUser";
import { ProcessUserStatusesEnum } from "@/store/modules/document/state";
import { t } from "@/i18n";
import { formatDateTime } from "@/utils/date";
import { resolveLocalizedMap } from "@/utils/localization";


export default /*#__PURE__*/_defineComponent({
  props: {
    processes: null
  },
  setup(__props: any) {

const props = __props as {
  processes: Process[];
}


const hasComments = computed(() => props.processes.some(process => Boolean(process.comment?.trim())));

const mainProcessUsers = (process: Process) =>
  (process.processUsers || []).filter((user) => !user.parentId);

const substituteFor = (process: Process, userProcess: ProcessUser) =>
  (process.processUsers || []).find(
    (user) => user.parentId === userProcess.id
  ) || null;

const processName = (process: Process) =>
  resolveLocalizedMap(
    process.templateInfo?.nameI18n,
    process.templateInfo?.name || "-"
  );

const statusIcons: Record<string, Component> = {
  [ProcessUserStatusesEnum.SUCCESS]: CheckIcon,
  [ProcessUserStatusesEnum.WAIT]: ClockIcon,
  [ProcessUserStatusesEnum.DENIED]: XIcon,
  [ProcessUserStatusesEnum.ACTIVE]: CogIcon,
  [ProcessUserStatusesEnum.CANCELLED]: XIcon,
};

const statusColors: Record<string, string> = {
  [ProcessUserStatusesEnum.SUCCESS]: "bg-green-500",
  [ProcessUserStatusesEnum.WAIT]: "bg-yellow-500",
  [ProcessUserStatusesEnum.DENIED]: "bg-red-500",
  [ProcessUserStatusesEnum.ACTIVE]: "bg-blue-500",
  [ProcessUserStatusesEnum.CANCELLED]: "bg-gray-500",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-scroll",
    style: {"--table-min-width":"1000px"},
    tabindex: "0",
    role: "region",
    "aria-label": _ctx.$t('common.scrollableTable')
  }, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)("processTable.process")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("common.status")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)("process.executor")), 1),
          (_unref(hasComments))
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_unref(t)("process.comment")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)("processTable.deadline")), 1),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)("processTable.start")), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("processTable.end")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.processes, (process, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_11, _toDisplayString(processName(process)), 1),
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass(["process-status-icon p-1 rounded-full text-white mx-auto w-max", statusColors[process.status]])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(statusIcons[process.status]), { class: "w-5 h-5 mx-auto" }))
              ], 2)
            ]),
            _createElementVNode("td", _hoisted_13, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainProcessUsers(process), (user) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: user.id
                  }, [
                    _createTextVNode(_toDisplayString(user.userInfo.fullName) + " ", 1),
                    (substituteFor(process, user))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (" + _toDisplayString(_unref(t)("processHistory.executedBy")) + ": " + _toDisplayString(substituteFor(process, user)?.userInfo.fullName) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            (_unref(hasComments))
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(process.comment?.trim() || ''), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatDateTime)(process.deadline)), 1),
            _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatDateTime)(process.createdAt)), 1),
            _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatDateTime)(process.finishedAt)), 1)
          ]))
        }), 128))
      ])
    ])
  ], 8, _hoisted_1))
}
}

})